import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-white/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-white"></i>
              </div>
              <span className="text-lg font-bold text-white whitespace-nowrap">{siteInfo.name}</span>
            </div>
            <p className="text-sm leading-relaxed text-white/60">
              {siteInfo.tagline} —— 您的韩漫阅读快捷通道，让找书变得更简单。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a className="no-underline text-white" href="#footer-links">快捷链接</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">全部分类</Link></li>
              <li><Link to="/category/romance" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">恋爱</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">奇幻</Link></li>
              <li><Link to="/about" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a className="no-underline text-white" href="#footer-categories">热门分类</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/category/action" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">动作</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">搞笑</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">悬疑</Link></li>
              <li><Link to="/category/bl" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">BL</Link></li>
              <li><Link to="/category/drama" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline">剧情</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a className="no-underline text-white" href="#footer-contact">联系我们</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-white/60">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-line text-xs"></i></div>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-white/60">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-time-line text-xs"></i></div>
                每日更新 · 全年无休
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            &copy; {currentYear} {siteInfo.name} 版权所有 | 免费韩漫大全 | 韩漫在线阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/50 hover:text-white transition-colors cursor-pointer" aria-label="微博">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-weibo-line"></i></div>
            </a>
            <a href="#" className="text-white/50 hover:text-white transition-colors cursor-pointer" aria-label="微信">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-wechat-line"></i></div>
            </a>
            <a href="#" className="text-white/50 hover:text-white transition-colors cursor-pointer" aria-label="QQ">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-qq-line"></i></div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}